import { mount } from '../../../js/dom-lifecycle';
import { rotateImage } from '../rotate-image';

mount('[data-receipt-lightbox]', (lightbox, refs) => {
    const { img, rotateLeft, rotateRight } = refs;
    rotateLeft.addEventListener('click', () => rotateImage(img, -90));
    rotateRight.addEventListener('click', () => rotateImage(img, +90));
    img.addEventListener('click', () => lightbox.closest('.basicLightbox').click());
});
